// load firebase dynamically

import store from '@sb/store'
var config = require('@sb/config')

async function initFcm () {
	var accid = store.user.account_id
	var href = window.location.href

	window.addEventListener('message', handleReceiveMessageFromWindowNotify)
	let firebase = await loadFirebase()
	//init firebase messaging
	if (!firebase.messaging.isSupported()) return

	firebase.initializeApp({
		projectId: config.FirebaseProjectID,
		messagingSenderId: config.FirebaseSenderID,
	})

	const messaging = firebase.messaging()
	if (!messaging) return
	messaging.usePublicVapidKey(config.FirebasePublicVapidKey)

	navigator.serviceWorker.addEventListener('message', async event => {
		if (!event.data || !event.data.conversation_id) return
		// router.push({ name: 'convo', params: { convoId: event.data.conversation_id } })
	})

	let sw = await navigator.serviceWorker.register(`${config.BaseURL}/service_worker.js`, { scope: '/' })
	if (!sw) return

	messaging.useServiceWorker(sw)
	let controler = navigator.serviceWorker.controller
	controler && controler.postMessage({ account_id: accid, default_url: window.btoa(href) })

	var tk
	try {
		tk = await messaging.getToken()
	} catch (e) {
		return
	}

	if (!tk) return
	// already regitered, publish token
	await store.setFcmToken(tk)
}

var $script = require('scriptjs')
function loadFirebase () {
	return new Promise((rs, rj) =>
		$script('https://www.gstatic.com/firebasejs/6.2.0/firebase-app.js', () =>
			$script('https://www.gstatic.com/firebasejs/6.2.0/firebase-messaging.js', () => rs(firebase)),
		),
	)
}

function handleReceiveMessageFromWindowNotify (event) {
	const data = event.data
	if (data.type !== 'SUBSCRIBED') return
	return store.setFcmToken(data.token)
}

export default initFcm
